<div *ngIf="reviewModal" (click)="onCloseClick()"
    class="modal position-fixed w-100 h-100 align-items-center justify-content-center"
    [ngClass]="{ 'active': reviewModal.isModalOpen }">
    <div (click)="onInsideClick($event)" class="mod-dialog">

        <div class="mod-header bg-color-14 d-flex flex-row align-items-center justify-content-between typo-title">
            <div class="px-2">
                <img src="assets/images/231116/Logo.png" alt="Prems AI Logo" class="my-logo">
            </div>
            <div class="typo-modal-header" [innerHTML]="'wap1_m_review_formTitle' | translate | safeMark"></div>
            <img class="mod-close mx-1" src="assets/images/231116/pictos/Close.svg" (click)="onCloseClick()" />
        </div>
        

        <div class="mod-body d-flex flex-column justify-content-center align-items-center p-2">

            <ng-container *ngIf="!reviewThankYou">
                <rating [overrideStars]="reviewModal.idRate-1">{{ 'wap1_m_review_yourRating' | translate }}</rating>

                <form class="w-100" [formGroup]="reviewForm">
                    <div class="rateText centered-content" [innerHtml]="'wap1_m_review_yourReview' | translate | safeMark"></div>
                    <textarea class="form-control" type="text" formControlName="review"
                        [placeholder]="'wap1_m_review_formGuide' | translate"></textarea>
                    <div class="color-error"
                        *ngIf="reviewSubmittedForm && reviewform['review'].errors && reviewform['review'].errors['required']">
                        {{ 'wap1_m_review_formLimit' | translate }}</div>
                    <div class="color-error"
                        *ngIf="reviewSubmittedForm && reviewform['review'].errors && reviewform['review'].errors['minlength']">
                        {{ 'wap1_m_review_formLimit' | translate }}</div>

                    <div class="d-flex flex-row align-items-end justify-content-end mt-3">
                        <btn-standard (click)="onReviewSubmit()">{{ 'wap1_m_review_formSubmit' | translate }}</btn-standard>
                    </div>
                </form>
            </ng-container>

            <ng-container *ngIf="reviewThankYou">
                <div class="rateText centered-content" [innerHtml]="'wap1_m_review_formThanks' | translate | safeMark"></div>
            </ng-container>

        </div>

    </div>
</div>